import { create, find, update } from './generic';
import { userFields } from './metadata/users';

export const userOptions = {
  managedFields: [
    userFields.ADDRESS_CITY,
    userFields.ADDRESS_STATE,
    userFields.ADDRESS_STREET,
    userFields.ADDRESS_ZIP,
    userFields.EMAIL,
    userFields.PHONE,
    userFields.USER_NAME,
  ],
  route: '/airtable/Users/Users',
};

async function createUser(user) {
  const found = await findUser(user.fields.Email);

  if (found) {
    return found;
  }

  const [created] = await create(userOptions, user);
  return created;
}

async function findUser(email) {
  if (!email) {
    return undefined;
  }

  const users = await find(userOptions, `LOWER({Email}) = '${email.toLowerCase()}'`);

  if (users.length > 1) {
    throw new Error(`Found more than one user with the email address ${email}.`);
  }

  const [user] = users;
  return user;
}

async function updateUser(user) {
  const users = await update(userOptions, user);

  const [updated] = users;
  return updated;
}

export {
  createUser,
  findUser,
  updateUser,
};
